// @generated by TypeGen from LogbookModel/Weather.swift - DO NOT EDIT

export interface IWeatherTimeseriesData {
  timeUtc: number;
  pressure?: number;
  temperature?: number;
  windDirection?: number;
  windSpeed?: number;
}

export enum ILogWeather {
  clearSky = 1,
  fine = 2,
  halfCloud = 3,
  cloudy = 4,
  overcast = 5,
  drizzle = 6,
  moderateRain = 7,
  heavyRain = 8,
  showerOfRain = 9,
  haze = 10,
  mist = 11,
  fog = 12,
  sleet = 13,
  hail = 14,
  thunderstorm = 15,
  snow = 16,
}
